/**
 * Web stub for Firebase Crashlytics
 * Provides minimal logging interface for web platform
 */

export default {
  log: (message: string) => {
    console.log('[Crashlytics]', message);
  },
  setUserId: (userId: string) => Promise.resolve(),
  recordError: (error: Error) => {
    console.error('[Crashlytics Error]', error);
  },
  setCrashlyticsCollectionEnabled: () => Promise.resolve(),
  isCrashlyticsCollectionEnabled: true,
};
